import { useState } from "react";
import { ChildById } from "../ComponentRenderer";
import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

interface TabItem {
  label?: string;
  componentId?: string;
}

export function Tabs({ fields, scope }: ComponentProps) {
  const items = useBound<TabItem[]>(fields.tabItems as BoundValue, scope) ?? [];
  const [active, setActive] = useState(0);

  if (items.length === 0) return <div className="a2-tabs-empty" />;
  const current = items[Math.min(active, items.length - 1)] ?? items[0]!;

  return (
    <div className="a2-tabs">
      <div className="a2-tabs-bar">
        {items.map((it, i) => (
          <button
            key={i}
            className={`a2-tab ${i === active ? "active" : ""}`}
            onClick={() => setActive(i)}
          >
            {it.label ?? `Tab ${i + 1}`}
          </button>
        ))}
      </div>
      <div className="a2-tabs-panel">
        {current.componentId
          ? <ChildById id={current.componentId} scope={scope} />
          : null}
      </div>
    </div>
  );
}
